import React from "react";

const SimpleInput = ({ name, value, placeholder, onChange }) => {
  return (
    <input
      className="custom-input"
      name={name}
      value={value}
      type="text"
      placeholder={placeholder}
      onChange={onChange}
    />
  );
};

export default SimpleInput;
